enum AccountReceivableHistoryOperationTypeEnum {
  INCREASE = 'I',
  DECREASE = 'D',
  CHANGE_EXPIRATION = 'E'
}

export default AccountReceivableHistoryOperationTypeEnum;
